import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PartnerRoutingModule } from '@pg-app/partner/partner-routing.module';
import { ChangeMemorableNumberModule } from '@pg-app/common/change-memorable-number/change-memorable-number.module';
import { ChangePasswordModule } from '@pg-app/common/change-password/change-password.module';
import { CoreUiModule } from '@nttp/core-ui';

@NgModule({
  imports: [CommonModule, PartnerRoutingModule, ChangeMemorableNumberModule, ChangePasswordModule, CoreUiModule],
  declarations: []
})
export class PartnerModule { }
